module.exports = __webpack_public_path__ + "img/freetools.fcf57b02.png";